export default "__VITE_ASSET__DD2iyeA5__"